
export default function DrivingHeroEn() {
  const handleLineBooking = () => {
    window.open('https://line.me/ti/p/~yokota0809', '_blank');
  };

  const whatsappNumber = '81909289552';
  const whatsappMessage = encodeURIComponent('Hello, I would like to book the Driving Assistant service.\nDate:\nTime:\nNumber of people:');
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5292e244f16d621856370f4609f661fc.jpg"
          alt="Tokyo Driving Assistance"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-zinc-900"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 py-32 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-amber-500/20 border border-amber-500/50 rounded-full px-6 py-2 mb-8">
          <i className="ri-alert-line text-amber-400 text-lg"></i>
          <span className="text-amber-300 font-medium text-sm whitespace-nowrap">Not a Transportation Business</span>
        </div>

        {/* Title */}
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Tokyo Driving<br />
          <span className="text-amber-400">Assistance Service</span>
        </h1>

        {/* Subtitle */}
        <p className="text-xl md:text-2xl text-gray-300 mb-4 max-w-3xl mx-auto leading-relaxed">
          Professional Support for Your Rental Car
        </p>
        <p className="text-base md:text-lg text-gray-400 mb-12 max-w-2xl mx-auto">
          We provide driving assistance for rental cars arranged by guests. We do not provide vehicle rental or paid transportation services.
        </p>

        {/* Features */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-12 max-w-4xl mx-auto">
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6">
            <div className="w-12 h-12 bg-amber-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-steering-2-line text-amber-400 text-2xl"></i>
            </div>
            <h3 className="text-white font-semibold mb-2 text-lg">Driving Support</h3>
            <p className="text-gray-400 text-sm">Safe and comfortable driving assistance</p>
          </div>
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6">
            <div className="w-12 h-12 bg-amber-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-map-pin-line text-amber-400 text-2xl"></i>
            </div>
            <h3 className="text-white font-semibold mb-2 text-lg">Navigation Help</h3>
            <p className="text-gray-400 text-sm">Parking and highway guidance</p>
          </div>
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6">
            <div className="w-12 h-12 bg-amber-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-guide-line text-amber-400 text-2xl"></i>
            </div>
            <h3 className="text-white font-semibold mb-2 text-lg">Local Guide</h3>
            <p className="text-gray-400 text-sm">Tokyo insider knowledge</p>
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={handleLineBooking}
            className="inline-flex items-center gap-3 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-black font-bold px-10 py-5 rounded-full text-lg transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-line-fill text-2xl"></i>
            Book via LINE
          </button>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-gradient-to-r from-[#25D366] to-[#128C7E] hover:from-[#20BA5A] hover:to-[#0F7A6A] text-white font-bold px-10 py-5 rounded-full text-lg transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            Book via WhatsApp
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-amber-400 text-3xl"></i>
      </div>
    </section>
  );
}